import { render, staticRenderFns } from "./CrFacebookDestination.vue?vue&type=template&id=287db76a&"
import script from "./CrFacebookDestination.vue?vue&type=script&lang=js&"
export * from "./CrFacebookDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports